import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Particle from '../Particle';
import Resumecontent from './ResumeContent';

import clogo from '../../Assets/clogo.svg';
import reflogo from '../../Assets/reflogo.png';
import ntlogo from '../../Assets/ntlogo.jpg';

function Workexp() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row className="resume">
          <Col md={8} className="resume-left">
            <h3 className="resume-title">WORK EXPERIENCE</h3>
            <Resumecontent
              title="Full Stack Developer"
              company="Neem Tree Agro Solutions"
              logo={ntlogo}
              date="May 2021 - August 2021"
              website="http://neemtreeagrico.in/"
              content={[
                'NT Agro is an AgTech Startup which won Top 10 AgTech Startup in India award by Silicon Magzine India.',
                'I was part of Web Dev Team and majorly developed MERN stack based projects',
                'Developed  RESTful APIs like NT-Kisan followed test-driven development, deployment and automation of services',
                'Implemented and assured data integrity ,security  by using SHA256 and RSA based encryption methods. ',
                'Worked with cross functional team to revamp the main website features and won  grant from NASSCOM foundation.',
              ]}
            />
            <Resumecontent
              title="Subject Matter Expert"
              company="Chegg Inc"
              website="https://www.chegg.com/"
              logo={clogo}
              date="March 2021 - Present"
              content={[
                'Freelance/Part-time work as a Computer Science  Subject matter expert in Chegg.',
                'I solve problems related to this subject asked by users around the globe.',
              ]}
            />
            <Resumecontent
              title="Software Developer Intern"
              logo={reflogo}
              company="Refier"
              website="https://refier.com/"
              date="Dec 2020 - March 2021"
              content={[
                'Refier is EdTech startup and I was assigned duties to develop and handle the main website and its tools using React-redux. ',
                'Prototyped/Designed robust, scalable React based tools for the company',
                ' Worked on Analytical Dashboard, ReportDashboards , Performed User Journey mapping and developed prototypes like job filters , portfolio themes',
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Workexp;
